import { useForm, Controller } from "react-hook-form";
import { IContaIuguDTO } from "../../../types/contaIugo";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { maskTime } from "../../../utils/masks";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Delivery } from "../../../services/Delivery";
import {
  IDeliveryAtualizarForm,
  IDeliveryAtualizarFormRHF,
} from "../../../types/delivery";

const schemaForm = z.object({
  horarioFinal: z.string().min(1, "Campo obrigatorio"),
  horarioFinalAlmoco: z.string().optional(),
  horarioFinalFds: z.string().optional(),
  horarioInicial: z.string().min(1, "Campo obrigatorio"),
  horarioInicialAlmoco: z.string().optional(),
  horarioInicialFds: z.string().optional(),
  margemAtendimento: z.string().min(1, "Campo obrigatorio"),
  quantidadeVagas: z.number(),
  quantidadeVagasConcessionaria: z.number(),
  tempoMedio: z.string().min(1, "Campo obrigatorio"),
  cidade: z.string().min(1, "Campo obrigatorio"),
  uf: z.string().min(1, "Campo obrigatorio"),
});

export const useAdminDeliveryDetail = () => {
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const uuidDelivery = searchParams.get("id");
  const [contaIugu, setContaIugu] = useState<IContaIuguDTO>(
    {} as IContaIuguDTO
  );

  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      horarioFinal: "",
      horarioFinalAlmoco: "",
      horarioFinalFds: "",
      horarioInicial: "",
      horarioInicialAlmoco: "",
      horarioInicialFds: "",
      margemAtendimento: "",
      quantidadeVagas: 0,
      tempoMedio: "",
      cidade: "",
      uf: "",
      quantidadeVagasConcessionaria: 0,
    },
    mode: "all",
    resolver: zodResolver(schemaForm),
  });

  function submitForm(data: IDeliveryAtualizarFormRHF) {
    setIsLoad(true);

    const PAYLOAD: IDeliveryAtualizarForm = {
      ...data,
      uuidDelivery: uuidDelivery,
    };

    Delivery.atualizar(PAYLOAD)
      .then(() => navigate("/configuracoes/deliverys"))
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  useEffect(() => {
    if (watch("horarioInicial")) {
      setValue("horarioInicial", maskTime(watch("horarioInicial")));
    }
  }, [watch("horarioInicial")]);

  useEffect(() => {
    if (watch("horarioFinal")) {
      setValue("horarioFinal", maskTime(watch("horarioFinal")));
    }
  }, [watch("horarioFinal")]);

  useEffect(() => {
    if (watch("horarioInicialAlmoco")) {
      setValue("horarioInicialAlmoco", maskTime(watch("horarioInicialAlmoco")));
    }
  }, [watch("horarioInicialAlmoco")]);

  useEffect(() => {
    if (watch("horarioFinalAlmoco")) {
      setValue("horarioFinalAlmoco", maskTime(watch("horarioFinalAlmoco")));
    }
  }, [watch("horarioFinalAlmoco")]);

  useEffect(() => {
    if (watch("horarioInicialFds")) {
      setValue("horarioInicialFds", maskTime(watch("horarioInicialFds")));
    }
  }, [watch("horarioInicialFds")]);

  useEffect(() => {
    if (watch("horarioFinalFds")) {
      setValue("horarioFinalFds", maskTime(watch("horarioFinalFds")));
    }
  }, [watch("horarioFinalFds")]);

  useEffect(() => {
    if (watch("tempoMedio")) {
      setValue("tempoMedio", maskTime(watch("tempoMedio")));
    }
  }, [watch("tempoMedio")]);

  useEffect(() => {
    if (watch("margemAtendimento")) {
      setValue("margemAtendimento", maskTime(watch("margemAtendimento")));
    }
  }, [watch("margemAtendimento")]);

  useEffect(() => {
    if (uuidDelivery) {
      setIsLoad(true);
      Delivery.getById({ uuidDelivery })
        .then(({ data }) => {
          setContaIugu(data.contaIugu);

          setValue("horarioFinal", data.horarioFinal || "");
          setValue("horarioFinalAlmoco", data.horarioFinalAlmoco || "");
          setValue("horarioFinalFds", data.horarioFinalFds || "");
          setValue("horarioInicial", data.horarioInicial || "");
          setValue("horarioInicialAlmoco", data.horarioInicialAlmoco || "");
          setValue("horarioInicialFds", data.horarioInicialFds || "");
          setValue("margemAtendimento", data.margemAtendimento || "");
          setValue("quantidadeVagas", data.quantidadeVagas || 0);
          setValue("quantidadeVagasConcessionaria", data.quantidadeVagasConcessionaria|| 0);
          setValue("tempoMedio", data.tempoMedio || "");
          setValue("cidade", data.cidade || "");
          setValue("uf", data.uf || "");
        })
        .catch(
          ({
            response: {
              data: { mensagem },
            },
          }) => toast.error(mensagem)
        )
        .finally(() => {
          setIsLoad(false);
        });
    }
  }, [uuidDelivery]);

  return {
    Controller,
    control,
    handleSubmit,
    errors,
    register,
    submitForm,
    watch,
    contaIugu,
  };
};
